<template>
    <div class="d-flex justify-content-center align-items-center form-data">
        <div>
            <h1 class="mb-3">Add a new password</h1>

            <form @submit.stop.prevent="updatePassword" :class="['shaded', status]">
                <input class="full" v-model="password" type="password" placeholder="Please write a new password" autofocus required>
                <input type="submit" class="btn action widest full" value="Update password">

                <router-link :to="{ name: 'auth.login' }" class="fs-smaller back">
                    Back to sign in
                </router-link>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                password: '',
                status: '',
            }
        },
        created: function() {
            if (!this.$route.query.userId || !this.$route.query.token) {
                this.$router.push({ name: 'auth.login' });
            }

            this.eventHub.$emit('sidebar', 'login');
            this.eventHub.$emit('topLink', 'signup');
        },
        methods: {
            updatePassword: function() {
                var vm = this;

                axios.post(axios.authURL + 'auth/ResetPasswordConfirmation', {
                    userId: this.$route.query.userId,
                    token: this.$route.query.token,
                    newPassword: this.password
                }).then(response => {
                    if (response && response.status === 200) {
                        vm.$toasted.success(response.data.message, { className: 'auth-alert' });
                        this.$router.push({ name: 'auth.login' });
                    }
                    else {
                        vm.$toasted.error(response.data.message, { className: 'auth-alert' });
                    }
                })
                .catch(function (error) {
                });
            }
        },
    }
</script>



// WEBPACK FOOTER //
// ResetPassword.vue?5252046d